import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
    ProductsResponseDto,
    SavingsInsightsOrderBy,
} from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsProductsParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
    orderBy?: SavingsInsightsOrderBy;
    page?: number;
}

export const fetchSavingsProducts = createAsyncThunk<
    ProductsResponseDto,
    FetchSavingsProductsParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsProducts',
    async (
        {
            dateFrom,
            dateTo,
            propertyIds,
            categoryIds,
            orderBy = '-total_saved',
            page = 1,
        },
        thunkApi,
    ) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const response = await extra.api.post<ProductsResponseDto>(
                '/v1/reports/savings-insights/products',
                {
                    dateFrom,
                    dateTo,
                    orderBy,
                    page,
                    pageSize: 25,
                    ...(propertyIds?.length
                        ? {
                              propertyIds,
                          }
                        : {}),
                    ...(categoryIds?.length
                        ? {
                              categoryIds,
                          }
                        : {}),
                },
            );
            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
